const { createRecipeTiles } = require('../../shop/tiles/recipe-tile-factory');

class RecipeListTileListController {
    constructor($window, settings, recipeListsService, sortByKeys, analyticsService) {
        this.$window = $window;
        this.settings = settings;
        this.recipeListsService = recipeListsService;
        this.sortByKeys = sortByKeys;
        this.analytics = analyticsService;
    }

    $onInit() {
        this.sortOptions = { sortTypes: this.settings.recipe.sortOptions, sortContext: this.sortByKeys.RECIPE_KEY };
    }

    pushToAnalytics(recipes, pageNumber, sortType) {
        this.analytics.push({
            data: {
                recipes,
                numberOfPage: pageNumber,
                pageSortBy: sortType,
                SortTypes: this.sortOptions.sortTypes,
                homeUrl: this.$window.location.origin,
            },
            type: this.analytics.mapperTypes.content.recipeCategory,
        });
    }

    createTiles(tiles) {
        return {
            items: createRecipeTiles(tiles.items),
            totalRecordCount: tiles.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType) {
        return this.recipeListsService.getSavedRecipes(pageSize, pageNumber, sortType)
            .then((recipes) => {
                const analyticsRecipes = { items: !!recipes && !!recipes.items ? recipes.items.map(recipe => ({ data: { recipe } })) : [] };
                this.pushToAnalytics(analyticsRecipes, pageNumber, sortType);
                return this.createTiles(recipes);
            });
    }
}

RecipeListTileListController.$inject = ['$window', 'Settings', 'RecipeListsService', 'SortByKeys', 'AnalyticsService'];

const recipeListTileListComponentDefinition = {
    bindings: {
        currentCategory: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: RecipeListTileListController,
    template: `
        <wow-tile-list
            list-title="::'My Favourite Recipes'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">
        </wow-tile-list>
    `,
};

module.exports = {
    RecipeListTileListController,
    recipeListTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-savedList/recipe-savedList-tile-list.component.js